import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const Sparkles = () => (
  <div className="sparkles">
    {[...Array(20)].map((_, i) => (
      <motion.div
        key={i}
        className="sparkle"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
        }}
        animate={{
          scale: [0, 1, 0],
          opacity: [0, 1, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          delay: Math.random() * 2,
        }}
      >
        {'\u2728'}
      </motion.div>
    ))}
  </div>
);

const DateNightTemplate = ({ question, onYes, showCta, cta, patternStyle = {} }) => {
  if (showCta) {
    return (
      <motion.div
        className="template date-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <Sparkles />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 1 }}
          >
            {'\uD83C\uDF19'}
          </motion.div>
          <h1>It's a Date!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83C\uDF77\uD83C\uDF39\uD83D\uDCAB\uD83C\uDF39\uD83C\uDF77'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template date-template">
      <div className="pattern-overlay" style={patternStyle} />
      <Sparkles />
      <div className="template-content">
        <motion.div
          className="moon-icon"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
        >
          {'\uD83C\uDF19'}
        </motion.div>

        <motion.h1
          className="invite-question"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {question}
        </motion.h1>

        <div className="button-container">
          <motion.button
            className="yes-button date-yes"
            onClick={onYes}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes! {'\uD83C\uDF39'}
          </motion.button>
        </div>
      </div>

      <RunawayButton className="date-no">
        Maybe not...
      </RunawayButton>
    </div>
  );
};

export default DateNightTemplate;
